














import { Component, Vue, Prop } from 'vue-property-decorator'
import openApp from '@ivy/fts/openApp'
@Component({
})
export default class Showapp extends Vue {
  @Prop() closeAll: () => void
  open() {
    return openApp()
  }
}
